import AOS from 'aos';

export default function initializeAllCollapses() {
    document.querySelectorAll( '[data-id-collapse]' ).forEach( function( block ) {
        new Collapse(block);
    } );
}

class Collapse {
    constructor(block) {
        this.block = block;
        this.init();
    }
    init() {
        const accordionItems = this.block.querySelectorAll('.block-collapse__accordion__item');

        accordionItems.forEach(item => {
            const header = item.querySelector('.block-collapse__accordion__header');
            const content = item.querySelector('.block-collapse__accordion__content');

            header.addEventListener('click', () => {
                item.classList.toggle('active');
                content.addEventListener('transitionend', e => {
                    if (e.propertyName === 'max-height') {
                        AOS.refresh();
                    }
                });
            });
        });
    }
}